<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-duotone fa-clipboard-list-check fa-fw"></i> Quality Assurance</h1>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view ref="routerView"></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row>
                <b-col>

                    <dashboard-side-data-widget label="Offers Ready for QA " :data="dashboardData.ordersQAStatus"
                                                icon="fa-light fa-pallet-alt"></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Offers Ready To Be Generated " :data="dashboardData.ordersOfferGenStatus"
                                                icon="fa-light fa-box-full"></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Orders in Appraisal Hold" :data="dashboardData.ordersHoldStatus" to="/search?filterField_0=status_id&filterModel_0=order&filterName_0=Order%20Status&filterParameter_0=equals&&filterValue_0=6"
                                                icon="fa-light fa-box-full"></dashboard-side-data-widget>


                    <b-card header="Scale Read Out" header-class="font-weight-bold" body-bg-variant="dark" v-if="state === 'quality-assurance-view'">
                        <ScaleWeight v-on:scale-stable="scaleStable = $event"
                                     v-on:scale-weight="$refs.routerView.scaleWeight = $event"
                                     ref="scale"></ScaleWeight>
                    </b-card>
                    <b-card body-class="p-0" header="Bag and Hold Confirmation Summary" header-class="font-weight-bold" v-if="state === 'quality-assurance-view' && viewLoaded">
                        <b-card class="border-0 mb-0" header-bg-variant="dark" body-class="p-0">
                            <template v-slot:header>
                                <b>Melt</b>
                            </template>
                            <b-table-simple class="mb-0" small >
                                <b-thead>
                                    <b-tr>
                                        <b-th>Metal</b-th>
                                        <b-th class=text-center>Bags</b-th>
                                        <b-th class="text-center">Items</b-th>
                                        <b-th class="text-right">Weight</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="(value, name, index) in $refs.routerView._getMeltItemsSummary" :key=index>
                                        <b-td>{{ name | titleCase }}</b-td>
                                        <b-td class="text-center">{{ $refs.routerView._getBagsByMetal[name].length }}</b-td>
                                        <b-td class="text-center">{{ value.items }}</b-td>
                                        <b-td class="text-right">{{ value.weight }} dwt</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-card>


                        <b-card class="border-0 mb-0" header-bg-variant="dark" body-class="p-0" v-if="state === 'quality-assurance-view' && viewLoaded">
                            <template v-slot:header>
                                <b>Hold</b>
                            </template>
                            <b-table-simple class="mb-0" small >
                                <b-thead>
                                    <b-tr>
                                        <b-th>Metal</b-th>
                                        <b-th class=text-center>Purity</b-th>
                                        <b-th class="text-center">Type</b-th>
                                        <b-th class="text-right">Weight</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody v-if="$refs.routerView.QA">
                                    <b-tr v-for="(value, index) in $refs.routerView.QA.holds" :key=index>
                                        <b-td>{{ value.class | titleCase }}</b-td>
                                        <b-td class="text-center">{{ value.purity | titleCase }} {{ value.purity_type }}</b-td>
                                        <b-td class="text-center">{{ value.type_name | titleCase }}</b-td>
                                        <b-td class="text-right">{{ value.dwt | toFixed2 }} dwt</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-card>

                    </b-card>

                </b-col>
            </b-row>
        </b-col>

    </b-row>
</template>

<script>
    import {
        BROADCAST_CONNECTED,
    } from '../../store/actions';
    import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
    import ScaleWeight from '@/components/ScaleWeight';
    import {assign} from 'lodash';

    export default {
        name: 'quality-assurance-index',
        title: 'Quality Assurance',
        components: {
            DashboardSideDataWidget,
            ScaleWeight,
        },
        data() {
            return {
                number: 0,
                viewLoaded: false,
                dashboardData: {
                    ordersQAStatus: null,
                    ordersOfferGenStatus: null,
                    ordersHoldStatus: null,
                },
            };
        },
        created() {

        },
        mounted() {
            this.viewLoaded = true;
            this.getDashboardData();

            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
        },
        beforeDestroy() {
            console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.QualityAssurance channel from QualityAssurance/index.vue.');
            this.$echo.leaveChannel('App.QualityAssurance');
        },
        methods: {
            joinBroadcastChannel: function () {
                console.info(String.fromCodePoint(0x1F91D) + ' Joining App.QualityAssurance channel from QualityAssurance/index.vue.');
                this.$echo.channel('App.QualityAssurance')
                    .listen('BroadcastDashboardUpdate', (e) => {
                        this.dashboardData = assign(this.dashboardData, e.payload);
                    });
            },
            getDashboardData(){
                this.$http.get('/dashboards/QA').then((response) => {
                    this.dashboardData = assign(this.dashboardData, response.data.data);
                });
            },
        },
        computed: {
            state: function () {
                return this.$route.name;
            },
        },
    };

</script>

<style scoped>
</style>
